import { Component, EventEmitter, Input, Output } from "@angular/core";
import { POEmailContact } from "../../../core/models/orders/poEmailContact";
import { TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";

@Component({
  selector: "jni-workflow-email-recipients",
  templateUrl: "./workflow-email-recipients.component.html",
  styleUrls: ["./workflow-email-recipients.component.scss"],
  imports: [TableModule, FormsModule, CommonModule, SelectModule],
})
export class WorkflowEmailRecipientsComponent {
  @Input() recipientsList: POEmailContact[] = [];
  @Output() recipientsDeletedEvent = new EventEmitter<POEmailContact[]>();
  @Output() recipientsAddEvent = new EventEmitter<boolean>();
  recipientsListSelected!: POEmailContact;
  recipientType = ["TO", "CC"];

  onDelete() {
    const recipientArray = [] as POEmailContact[];
    recipientArray.push(this.recipientsListSelected);
    this.recipientsDeletedEvent.emit(recipientArray);
    this.recipientsListSelected = {} as POEmailContact;
  }

  onAdd() {
    this.recipientsAddEvent.emit(true);
    this.recipientsListSelected = {} as POEmailContact;
  }
}
